export interface ReducerState {
  unread: boolean;
  archived: boolean;
  notification_type: string;
  recipient: string;
}

export type ReducerAction =
  | { type: 'toggleUnRead' }
  | { type: 'changeType'; payload: { type: string } };

export const initialState: ReducerState = {
  unread: true,
  archived: false,
  notification_type: 'all',
  recipient: 'in-app',
};

export function notificationReducer(
  state: ReducerState,
  action: ReducerAction
): ReducerState {
  switch (action.type) {
    case 'toggleUnRead':
      return { ...state, unread: !state?.unread };
    case 'changeType': {
      const { type } = action.payload;
      return { ...state, notification_type: type };
    }
    default:
      return state;
  }
}
